import ClientLogos from "@components/new-ui/ClientLogos";
import NewLayout from "@components/new-ui/Layout";
import YoutubeModal from "@components/new-ui/YoutubeModal";
import YellowCTAhref from "@components/yellowCTAhref";
import { windowOpenNewTab } from "@utils/common";
import "keen-slider/keen-slider.min.css";
import Image from "next/image";
import React, { FC, useEffect, useState } from "react";
import { IoChevronBackCircleOutline, IoChevronForwardCircleOutline } from "react-icons/io5";
import { MdArrowOutward } from "react-icons/md";

export const CASE_STUDIES = [
    {
        id: 1,
        bannerimg: "https://assets.gallabox.com/gb-home/qatar-insurance-company/header-image.png",
        tag: "Qatar Insurance Company",
        title: "How Qatar Insurance Company Doubled Lead Generation with Gallabox",
        link: "/case-study/qatar-insurance-company",
    },
    {
        id: 2,
        bannerimg: "https://assets.gallabox.com/gb-home/property2x/property2x-header.png",
        tag: "Real estate",
        title: "How Property2X Used Gallabox to Achieve a 300% Increase in Gross Profit",
        link: "/case-study/property2x",
    },
    {
        id: 3,
        bannerimg: "https://assets.gallabox.com/gb-home/hugg/hugg-header.png",
        tag: "D2C",
        title: "Maximizing Conversions and Streamlining Support : Hugg's Transformation",
        link: "/case-study/hugg",
    },
    {
        id: 4,
        bannerimg: "https://assets.gallabox.com/gb-home/go-ireland/goireland-header.png",
        tag: "Education",
        title: "How GoIreland Used Gallabox to Increase Conversions by 39%",
        link: "/case-study/goireland",
    },

    {
        id: 5,
        bannerimg: "https://assets.gallabox.com/gb-home/case-study/case-study-banner-1.png",
        tag: "Travel & Tourism",
        title: "LivingStone Stays Relocated Their Communications From IVR..",
        link: "/case-study/livingstone-stay",
    },
    {
        id: 6,
        bannerimg: "https://assets.gallabox.com/gb-home/case-study/case-study-banner-3.png",
        tag: "HR & Professional Service",
        title: "Jobstars India Deployed a Multilingual Chatbot to Handle 60%..",
        link: "/case-study/jobstars-india",
    },
    {
        id: 7,
        bannerimg: "https://assets.gallabox.com/gb-home/case-study/vcare/vcare-banner-img.png",
        tag: "Healthcare",
        title: "VCare increases their lead generation, conversion rate, and the quality of..",
        link: "/case-study/vcare",
    },
    {
        id: 8,
        bannerimg: "https://assets.gallabox.com/gb-home/case-study/numberwale/numberwale-banner-img.png",
        tag: "Telecom",
        title: "Numberwale increases their sales by nearly 25% with the help of Gallabox.",
        link: "/case-study/numberwale",
    },
    {
        id: 9,
        bannerimg: "https://assets.gallabox.com/gb-home/case-study/propleaf/propleaf-banner-img.png",
        tag: "Real estate",
        title: "PropLeaf Realty Tech increases their connect ratio with customers by 25%.",
        link: "/case-study/propleaf",
    },
    {
        id: 10,
        bannerimg: "https://assets.gallabox.com/gb-home/case-study/curioed/curioed-banner-img-new.png",
        tag: "Education",
        title: "CurioEd increases their engagement rate by 40%.",
        link: "/case-study/curioed",
    },
    {
        id: 11,
        bannerimg: "https://assets.gallabox.com/gb-home/case-study/case-study-banner-2.png",
        tag: "Retail, D2C",
        title: "Sattvic Stores Reduced RTO by 10% within a month of using Gallabox..",
        link: "/case-study/sattvic-store",
    },
];
export const CaseStudyHomePageInput = CASE_STUDIES.slice(0, 3);
interface CasestudyHerosection {
    title: string;
    description: string;
    imageUrl: string;
    externalLink: string;
    youtubeId?: string;
}

interface SliderHerosectionProps {
    HerosectionData: CasestudyHerosection[];
}

export interface CasestudyCardProps {
    imageUrl: string;
    title: string;
    externalLink: string;
    sector: string;
}

const HerosectionData: CasestudyHerosection[] = [
    {
        title: "How Shams achieved 50% higher response rates with Gallabox",
        description: "Sharjah Media City uses Gallabox to automate workflows, respond faster, and deliver more personalized customer engagement across channels.",
        imageUrl: "https://img.youtube.com/vi/qBEDB1DyciQ/hqdefault.jpg",
        externalLink: "https://www.youtube.com/shorts/qBEDB1DyciQ",
        youtubeId: "qBEDB1DyciQ",
    },
    {
        title: "How Thrillophilia scaled WhatsApp communication with Gallabox",
        description: "Discover why Thrillophilia chose Gallabox for workflows, automation, and custom communication needs beyond basic WhatsApp messaging.",
        imageUrl: "https://img.youtube.com/vi/mT8vmOA-5PM/hqdefault.jpg",
        externalLink: "https://www.youtube.com/watch?v=mT8vmOA-5PM",
        youtubeId: "mT8vmOA-5PM",
    },
    {
        title: "Streamlining lead nurturing, scaling conversations: Sotheby's Realty's success with Gallabox",
        description:
            "Sotheby's Realty transformed WhatsApp into a structured communication channel supporting lead nurturing, automated responses, and bulk outreach — engaging luxury real estate prospects more effectively.",
        imageUrl: "https://assets.gallabox.com/gb-home/case-study/sotheby/worker/man-worker.png",
        externalLink: "/case-study/sothebysrealty",
    },
    {
        title: "Gallabox powers Pickyourtrail's WhatsApp marketing success",
        description:
            "Discover how Pickyourtrail revolutionized their WhatsApp marketing campaigns and streamlined customer communication for travel using Gallabox's innovative solutions.",
        imageUrl: "https://assets.gallabox.com/gb-home/case-study/pickyourtrail.png",
        externalLink: "/case-study/pickyourtrail",
    },
    {
        title: "Round-the-clock luxury, powered by WhatsApp: MKV Luxury's success with Gallabox",
        description:
            "MKV Luxury used Gallabox to automate their WhatsApp customer communication, enabling round-the-clock availability and measurable improvements in booking operations.",
        imageUrl: "https://assets.gallabox.com/gb-home/case-study/mkvluxury/mkv/header.png",
        externalLink: "/case-study/mkvluxury",
    },
    {
        title: "Apollo JBP Hospitals | Healthcare × WhatsApp Automation",
        description: "Discover how Apollo JBP Hospitals transformed patient communication and marketing using Gallabox's WhatsApp automation platform.",
        imageUrl: "https://assets.gallabox.com/gb-home/case-study/apollo-jbp-hospitals.png",
        externalLink: "/case-study/apollo-jbp-hospitals",
    },
    {
        title: "Gallabox transforms Dubai Housekeeping's journey to service excellence on WhatsApp",
        description: "Discover how Dubai Housekeeping transformed their customer communication, scaled operations, and put convenience first using Gallabox's WhatsApp automation.",
        imageUrl: "https://assets.gallabox.com/gb-home/case-study/dubai-housekeeping.png",
        externalLink: "/case-study/dubai-housekeeping",
    },
    {
        title: "Gallabox revolutionizes lead engagement for Footprint Real Estate",
        description:
            "Find out how Footprint Real Estate transformed their WhatsApp lead engagement and customer communication using Gallabox's innovative features, achieving exceptional growth in conversions and customer acquisition.",
        imageUrl: "https://assets.gallabox.com/gb-home/case-study/footprint-real-estate.png",
        externalLink: "/case-study/footprint-real-estate",
    },
];

export const casestudyCards: CasestudyCardProps[] = [
    {
        imageUrl: "https://assets.gallabox.com/gb-home/case-study/hallofqatar/header.png",
        title: "How Mall of Qatar resolved 97.7% of visitor queries with an AI chatbot",
        sector: "Hospitality & Retail",
        externalLink: "/case-study/mall-of-qatar",
    },
    {
        imageUrl: "https://assets.gallabox.com/gb-home/case-study/agsons/header.png",
        title: "How AGSONS Middle East stopped losing leads in a WhatsApp group chat",
        sector: "Construction",
        externalLink: "/case-study/agsons-middle-east",
    },
    {
        imageUrl: "https://assets.gallabox.com/gb-home/case-study/protect/header.png",
        title: "How Protect4less cut support response time and improved customer satisfaction by 50%",
        sector: "Insurance & Device Protection",
        externalLink: "/case-study/protect4less",
    },
    {
        imageUrl: "https://assets.gallabox.com/gb-home/case-study/bluemagic/header.png",
        title: "How BlueMagic Group turned website interest into booked consultations",
        sector: "Healthcare",
        externalLink: "/case-study/bluemagic-group-international",
    },
    {
        imageUrl: "https://assets.gallabox.com/gb-home/case-study/bridgeretreats/header.png",
        title: "How Bridge Retreats took control of their WhatsApp marketing",
        sector: "Travel & Hospitality",
        externalLink: "/case-study/bridge-retreats",
    },
    {
        imageUrl: "https://assets.gallabox.com/gb-home/case-study/pawland/header.png",
        title: "How Pawland rebuilt customer trust after switching from WAPI to Gallabox",
        sector: "Professional Services",
        externalLink: "/case-study/pawland-domestic-pets-boarding",
    },
    {
        imageUrl: "https://assets.gallabox.com/gb-home/case-study/innovana/header.png",
        title: "How Innovana Fitness Labs stopped guessing and grew first-time conversions by 60%",
        sector: "Health & Fitness",
        externalLink: "/case-study/innovana-fitness-labs",
    },
    {
        imageUrl: "https://assets.gallabox.com/gb-home/case-study/intercity/header.png",
        title: "How Intercity Xpress connected customers and their tech team on WhatsApp",
        sector: "Logistics and Delivery",
        externalLink: "/case-study/intercity-xpress",
    },
    {
        imageUrl: "https://assets.gallabox.com/gb-home/case-study/kayeco/header.png",
        title: "How Kaye & Co Real Estate grew first-time conversions by 25% using WhatsApp automation",
        sector: "Real Estate",
        externalLink: "/case-study/kaye-co-real-estate",
    },
    {
        imageUrl: "https://assets.gallabox.com/gb-home/case-study/klink/header.png",
        title: "Replacing hundreds of calls with one broadcast: K-Link Consulting's success with Gallabox",
        sector: "Professional Services",
        externalLink: "/case-study/klinkconsulting",
    },
    {
        imageUrl: "https://assets.gallabox.com/gb-home/case-study/sotheby/worker/man-worker-measuring.png",
        title: "Streamlining lead nurturing, scaling conversations: Sotheby's Realty's success with Gallabox",
        sector: "Luxury Real Estate",
        externalLink: "/case-study/sothebysrealty",
    },
    {
        imageUrl: "https://assets.gallabox.com/gb-home/case-study/mkvluxury/mkv/round-the-clock.png",
        title: "Round-the-clock luxury, powered by WhatsApp: MKV Luxury's success with Gallabox",
        sector: "Luxury Car Rental",
        externalLink: "/case-study/mkvluxury",
    },
    {
        imageUrl: "https://assets.gallabox.com/gb-home/case-study/rakez/header.png",
        title: "Turning enquiries into entrepreneurs: Shuraa Business Setup's success with Gallabox",
        sector: "Business Services",
        externalLink: "/case-study/shuraabusinesssetup",
    },
    {
        imageUrl: "https://assets.gallabox.com/gb-home/case-study/villacare/plus/villa-work.png",
        title: "From enquiry to invoice, all on WhatsApp: Villacare Plus's success with Gallabox",
        sector: "Professional Services",
        externalLink: "/case-study/villacareplus",
    },
    {
        imageUrl: "https://assets.gallabox.com/gb-home/case-study/konze/konze.png",
        title: "How KONZE streamlined lead generation with Gallabox",
        sector: "Technology & Education Solutions",
        externalLink: "/case-study/konze",
    },
    {
        imageUrl: "https://assets.gallabox.com/gb-home/case-study/global-views/global-views.png",
        title: "Global Views MENA's growth story: From manual chaos to seamless messaging",
        sector: "Retail & Distribution",
        externalLink: "/case-study/global-views",
    },
    {
        imageUrl: "https://assets.gallabox.com/gb-home/case-study/til-limited/til-limited.png",
        title: "TIL Limited boosts lead generation and customer engagement with Gallabox",
        sector: "Manufacturing",
        externalLink: "/case-study/til-limited",
    },
    {
        imageUrl: "https://assets.gallabox.com/gb-home/case-study/inlingua/inlingua.png",
        title: "Inlingua doubles growth by streamlining student engagement with Gallabox",
        sector: "Education",
        externalLink: "/case-study/inlingua",
    },
    {
        imageUrl: "https://assets.gallabox.com/gb-home/case-study/khivraj-elixir/khivraj-elixir.png",
        title: "Khivraj Elixir shifts gears on customer engagement with Gallabox",
        sector: "Automobiles",
        externalLink: "/case-study/khivraj-elixir",
    },
    {
        imageUrl: "https://assets.gallabox.com/gb-home/case-study/alHilal/alHilal.png",
        title: "How Al Hilal Houri Medical Equipment streamlined support and achieved 60% growth with Gallabox",
        sector: "Healthcare",
        externalLink: "/case-study/alHilal",
    },
    {
        imageUrl: "https://assets.gallabox.com/gb-home/case-study/yaticorp/yaticorp.png",
        title: "How Yaticorp achieved 100% business growth by transforming their communication with Gallabox",
        sector: "IT Services",
        externalLink: "/case-study/yaticorp",
    },
    {
        imageUrl: "https://assets.gallabox.com/gb-home/case-study/ashoka/ashoka.png",
        title: "How Ashoka Group scaled their franchise empire to 900+ locations with Gallabox",
        sector: "Professional Services",
        externalLink: "/case-study/ashoka",
    },
    {
        imageUrl: "https://assets.gallabox.com/gb-home/case-study/nura/nura.png",
        title: "How NURA Ai Health Screening Simplified Operations with Gallabox",
        sector: "Healthcare",
        externalLink: "/case-study/nura",
    },
    {
        imageUrl: "https://assets.gallabox.com/gb-home/case-study/laPara/laPara.png",
        title: "How La Para Transformed Customer Experience with Gallabox",
        sector: "Hospitality",
        externalLink: "/case-study/la-para",
    },
    {
        imageUrl: "https://assets.gallabox.com/gb-home/case-study/edzeb/edzeb.png",
        title: "How edZeb Technologies simplified lead engagement with Gallabox",
        sector: "Technology Services",
        externalLink: "/case-study/edzeb",
    },
    {
        imageUrl: "https://assets.gallabox.com/gb-home/case-study/burgerman/burgerman.png",
        title: "How Young Franchise Holdings LLP boosted customer retention and business growth with Gallabox",
        sector: "Food & Beverage",
        externalLink: "/case-study/burgerman",
    },
    {
        imageUrl: "https://assets.gallabox.com/gb-home/case-study/panamax.svg",
        title: "How Panamax Infotech streamlined customer support with Gallabox",
        sector: "Service",
        externalLink: "/case-study/panamax-infotech",
    },
    {
        imageUrl: "https://assets.gallabox.com/gb-home/case-study/sedar-global.png",
        title: "How Sedar Global improved organisational communication with Gallabox",
        sector: "Service",
        externalLink: "/case-study/sedar-global",
    },
    {
        imageUrl: "https://assets.gallabox.com/gb-home/case-study/shuraa-tax.png",
        title: "How Shuraa Tax Accounting & Auditing enhanced communication with Gallabox",
        sector: "Service",
        externalLink: "/case-study/shuraa-tax-accounting-auditing",
    },
    {
        imageUrl: "https://assets.gallabox.com/gb-home/case-study/apollo-jbp-hospitals.png",
        title: "How Apollo JBP Hospitals transformed patient communication and marketing with Gallabox",
        sector: "Healthcare",
        externalLink: "/case-study/apollo-jbp-hospitals",
    },
    {
        imageUrl: "https://assets.gallabox.com/gb-home/case-study/roca-bathroom-product.png",
        title: "How Roca Bathroom Product Pvt. Ltd. scaled customer engagement with Gallabox",
        sector: "Professional services",
        externalLink: "/case-study/roca-bathroom-product",
    },
    {
        imageUrl: "https://assets.gallabox.com/gb-home/case-study/odysse/odysse.png",
        title: "How Odysse Electric Vehicles charged up 70% business growth with Gallabox",
        sector: "PROFESSIONAL SERVICES",
        externalLink: "/case-study/odysse-electric-vehicles",
    },
    {
        imageUrl: "https://assets.gallabox.com/gb-home/case-study/blueguard.png",
        title: "How BGME First aid training scaled revenue on WhatsApp with Gallabox",
        sector: "PROFESSIONAL SERVICES",
        externalLink: "/case-study/blueguard-middle-east-first-aid-training",
    },
    {
        imageUrl: "https://assets.gallabox.com/gb-home/case-study/hydrojeen.png",
        title: "How Hydrojeen simplified support and boosted growth by 30% with Gallabox",
        sector: "D2C",
        externalLink: "/case-study/hydrojeen",
    },
    {
        imageUrl: "https://assets.gallabox.com/gb-home/case-study/intercityxpress.png",
        title: "How InterCityXpress doubled their business on WhatsApp with Gallabox",
        sector: "TRAVEL/LOGISTICS",
        externalLink: "/case-study/intercityxpress",
    },
    {
        imageUrl: "https://assets.gallabox.com/gb-home/case-study/tarabily.png",
        title: "How Tarabily scaled to 100% growth and customer satisfaction with Gallabox",
        sector: " PRINTING & DESIGN",
        externalLink: "/case-study/tarabily",
    },

    {
        imageUrl: "https://assets.gallabox.com/gb-home/case-study/acharya-academy.png",
        title: "How 1729 Acharya Academy achieved 75% growth and 90% parent satisfaction with Gallabox",
        sector: "EDUCATION",
        externalLink: "/case-study/1729-acharya-academy",
    },
    {
        imageUrl: "https://assets.gallabox.com/gb-home/case-study/fleetoz.png",
        title: "FleetOz automates lead capture and closes deals faster using Gallabox’s WhatsApp bot",
        sector: "LOGISTICS",
        externalLink: "/case-study/fleetoz",
    },
    {
        imageUrl: "https://assets.gallabox.com/gb-home/case-study/iskcon.png",
        title: "ISKCON revolutionizes devotee engagement with Gallabox",
        sector: "RELIGIOUS INSTITUTION",
        externalLink: "/case-study/iskcon",
    },
    {
        imageUrl: "https://assets.gallabox.com/gb-home/case-study/mrmed.png",
        title: "MrMed enhances retention and support with WhatsApp automation",
        sector: "HEALTHCARE",
        externalLink: "/case-study/mrmed",
    },

    {
        imageUrl: "https://assets.gallabox.com/gb-home/case-study/thread-bucket-studio/thread-bucket-studio.png",
        title: " Why Thread Bucket Studio chose Gallabox over Wati for seamless team communication",
        sector: "E-COMMERCE",
        externalLink: "/case-study/thread-bucket-studio",
    },
    {
        imageUrl: "https://assets.gallabox.com/gb-home/case-study/rostrum-card-image.png",
        title: "Gallabox transforms WhatsApp marketing for Rostrum Education",
        sector: "Education",
        externalLink: "/case-study/rostrum-education",
    },
    {
        imageUrl: "https://assets.gallabox.com/gb-home/case-study/pickyourtrail.png",
        title: "Gallabox powers Pickyourtrail's WhatsApp marketing success",
        sector: "Travel",
        externalLink: "/case-study/pickyourtrail",
    },
    {
        imageUrl: "https://assets.gallabox.com/gb-home/case-study/footprint-real-estate.png",
        title: "Gallabox revolutionizes lead engagement for Footprint Real Estate",
        sector: "Real Estate",
        externalLink: "/case-study/footprint-real-estate",
    },
    {
        imageUrl: "https://assets.gallabox.com/gb-home/case-study/educenter.png",
        title: "How Educenter used WhatsApp to empower students and increased revenue by 40%",
        sector: "Education",
        externalLink: "/case-study/educenter",
    },
    {
        imageUrl: "https://assets.gallabox.com/gb-home/case-study/dubai-housekeeping.png",
        title: "Gallabox transforms Dubai Housekeeping's journey to service excellence on WhatsApp",
        sector: "Service",
        externalLink: "/case-study/dubai-housekeeping",
    },

    {
        imageUrl: "https://assets.gallabox.com/gb-home/case-study/alrannan-admin-service.png",
        title: "How Alrannan Administrative Services automated sales with Gallabox",
        sector: "Service",
        externalLink: "/case-study/alrannan-administrative-services",
    },
    {
        imageUrl: "https://assets.gallabox.com/gb-home/case-study/itees-eye-hospital.png",
        title: "Gallabox improves patient experience at ITEES Eye Hospital on WhatsApp",
        sector: "Healthcare",
        externalLink: "/case-study/itees",
    },
    {
        imageUrl: "https://assets.gallabox.com/gb-home/case-study/goireland.png",
        title: "GoIreland's Success Story : Improved Transparency and Increased Conversions",
        sector: "Education",
        externalLink: "/case-study/goireland",
    },
    {
        imageUrl: "https://assets.gallabox.com/gb-home/case-study/qatar-insurance-company.png",
        title: "How Qatar Insurance Company doubled lead generation with Gallabox",
        sector: "Finance",
        externalLink: "/case-study/qatar-insurance-company",
    },
    {
        imageUrl: "https://assets.gallabox.com/gb-home/case-study/property-2x.png",
        title: "How Property2X used Gallabox to achieve a 300% increase in gross profit",
        sector: "Real Estate",
        externalLink: "/case-study/property2x",
    },

    {
        imageUrl: "https://assets.gallabox.com/gb-home/case-study/juttichoo/juttichoo-hero-image.png",
        title: "How JuttiChoo boosted sales & customer engagement with Gallabox",
        sector: "D2C",
        externalLink: "/case-study/juttichoo",
    },

    {
        imageUrl: "https://assets.gallabox.com/gb-home/case-study/hugg.png",
        title: "How Hugg scaled conversions by 30% with Gallabox's WhatsApp automation",
        sector: "D2C",
        externalLink: "/case-study/hugg",
    },
    {
        imageUrl: "https://assets.gallabox.com/gb-home/case-study/living-stone.png",
        title: "How LivingStone Stays streamlined their sales, marketing, and support using Gallabox",
        sector: "Travel",
        externalLink: "/case-study/livingstone-stay",
    },
    {
        imageUrl: "https://assets.gallabox.com/gb-home/case-study/jobstars-india.png",
        title: "How Jobstars India hit 60% conversions using Gallabox's multilingual WhatsApp bot",
        sector: "HR/Recruitment",
        externalLink: "/case-study/jobstars-india",
    },
    {
        imageUrl: "https://assets.gallabox.com/gb-home/case-study/vcare.png",
        title: "VCare increases Facebook ad returns by 15% with Gallabox's Click-to-WhatsApp Ads",
        sector: "Healthcare",
        externalLink: "/case-study/vcare",
    },
    {
        imageUrl: "https://assets.gallabox.com/gb-home/case-study/telecom.png",
        title: "Numberwale increases their sales by nearly 25% with the help of Gallabox.",
        sector: "Telecom",
        externalLink: "/case-study/numberwale",
    },
    {
        imageUrl: "https://assets.gallabox.com/gb-home/case-study/properleaf.png",
        title: "How PropLeaf increased customer connect ratio by 25% with Gallabox's shared WhatsApp inbox",
        sector: "Real Estate",
        externalLink: "case-study/propleaf",
    },
    {
        imageUrl: "https://assets.gallabox.com/gb-home/case-study/curoid.png",
        title: "CurioEd increases open rates by 38% with Gallabox's WhatsApp Business API",
        sector: "Education",
        externalLink: "/case-study/curioed",
    },
    {
        imageUrl: "https://assets.gallabox.com/gb-home/case-study/%20sattvic-store.png",
        title: "How Sattvic Store acquired 2000+ customers with Gallabox's WhatsApp chatbots",
        sector: "D2C",
        externalLink: "/case-study/sattvic-store",
    },

    {
        imageUrl: "https://assets.gallabox.com/gb-home/case-study/banking-academy.png",
        title: "How Banking Academy scaled lead generation by 100% and grew business by 49% with Gallabox",
        sector: "EDUCATION",
        externalLink: "/case-study/banking-academy",
    },
];

const CaseStudyPages: FC = () => {
    return (
        <NewLayout
            title="Customer Case Studies | Gallabox"
            description="See how our customers of all sizes have grown using Gallabox Shared Inbox, WhatsApp No-Code Chatbot and WhatsApp Broadcasts  to increase their lead generation and conversion rate."
            canonical="https://gallabox.com/case-study"
        >
            <section className="md:pt-40 pb-20 pt-10">
                <h1 className="text-7xl md:text-left text-center font-bold gap-2 md:mb-5 mb-2 max-w-6xl mx-auto" style={{ fontFamily: "Degular Variable", color: "#3364FA" }}>
                    Customer Stories
                </h1>
                <SliderHerosection HerosectionData={HerosectionData} />
            </section>

            <div className="lg:max-w-7xl mx-auto pt-20 pb-20">
                <h3 className="text-base text-center font-normal py-2">
                    Trusted by <span className="font-bold">10,000+ businesses</span>
                </h3>
                <ClientLogos />
            </div>

            <section className="bg-gray-100 md:py-20 py-10">
                <h3 className="text-gray-900 max-w-6xl mx-auto mb-10  mt-5 text-center md:text-left ">Check out other customer stories</h3>
                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 max-w-6xl mx-auto gap-y-10">
                    {casestudyCards?.map((data, index) => (
                        <CasestudyCard key={index} {...data} />
                    ))}
                </div>
            </section>

            <section className="flex md:flex-row flex-col max-w-6xl mx-auto md:justify-between mt-24 mb-20 px-4 md:px-0">
                <div className="mb-10 md:mb-4">
                    <p className="text-blue-500 font-semibold">AWARDS</p>
                    <h3 className="text-3xl">
                        Recognized by <br></br> industry leaders
                    </h3>
                </div>
                <img src="/casestudybatch.png" alt="casestudy-batch" />
            </section>

            <YellowCTAhref
                buttonText="Signup for free"
                secondaryButtonText="Book a Demo"
                link2="https://gallabox.com/demo"
                customText={"Transform your goals into wins with Gallabox"}
                cardStyles={{ cardColor: "#E2E8F0", cardTextColor: "black" }}
            />
        </NewLayout>
    );
};

export default CaseStudyPages;

const SliderHerosection: React.FC<SliderHerosectionProps> = ({ HerosectionData }) => {
    const [currentIndex, setCurrentIndex] = useState(0);
    const [activeVideoId, setActiveVideoId] = useState<string | null>(null);

    const nextSlide = () => {
        setCurrentIndex((prevIndex) => (prevIndex === HerosectionData.length - 1 ? 0 : prevIndex + 1));
    };

    const prevSlide = () => {
        setCurrentIndex((prevIndex) => (prevIndex === 0 ? HerosectionData.length - 1 : prevIndex - 1));
    };

    useEffect(() => {
        if (activeVideoId) return;
        const interval = setInterval(nextSlide, 3000);
        return () => clearInterval(interval);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [currentIndex, activeVideoId]);

    return (
        <>
            <section className="slider-container relative max-w-6xl mx-auto" style={{ minHeight: "500px", display: "flex", flexDirection: "column", justifyContent: "center" }}>
                <div className="keen-slider relative overflow-hidden" style={{ height: "100%" }}>
                    {HerosectionData.map((data, index) => (
                        <div
                            key={index}
                            className={`slider-card flex md:flex-row flex-col justify-between items-center transition-opacity duration-500 ${
                                currentIndex === index ? "opacity-100 shadow-lg" : "opacity-0 absolute pointer-events-none"
                            }`}
                            style={{ minHeight: "500px", alignItems: "center" }}
                        >
                            <div className="flex flex-col lg:w-1/2 lg:mx-0 w-fit mx-2 self-start">
                                <div className="flex flex-col gap-6">
                                    <p className="md:text-5xl font-bold mb-2 text-3xl lineheight text-center md:text-left leading-10">{data.title}</p>
                                    <p className="text-gray-600 md:text-left text-center">{data.description}</p>
                                    {!data.youtubeId && (
                                        <a
                                            className="md:ml-0 px-6 py-4 bg-blue-600 text-white flex items-center gap-x-2 font-semibold mt-4 mx-auto hover:no-underline rounded"
                                            href={data.externalLink}
                                        >
                                            Read the story
                                            <span>
                                                <MdArrowOutward size={20} />
                                            </span>
                                        </a>
                                    )}
                                </div>
                            </div>
                            <div className="px-2 md:px-0 pt-4 md:pt-0 relative">
                                <Image src={data.imageUrl} alt={data.title} width={500} height={500} className="rounded-lg shadow-md" />
                                {data.youtubeId && (
                                    <button className="absolute inset-0 flex items-center justify-center" onClick={() => setActiveVideoId(data.youtubeId!)} aria-label="Play video">
                                        <div className="bg-white bg-opacity-90 rounded-full w-16 h-16 flex items-center justify-center shadow-lg hover:bg-opacity-100 transition-all">
                                            <svg className="w-7 h-7 text-gray-800 ml-1" viewBox="0 0 24 24" fill="currentColor">
                                                <path d="M8 5v14l11-7z" />
                                            </svg>
                                        </div>
                                    </button>
                                )}
                            </div>
                        </div>
                    ))}
                </div>
                <div className="flex w-2/3 mt-5 md:mt-0 md:ml-auto gap-x-">
                    <div className="ml-auto cursor-pointer" onClick={prevSlide}>
                        <IoChevronBackCircleOutline size={50} className="text-gray-700 hover:text-gray-900 self-center" />
                    </div>
                    <div className="cursor-pointer" onClick={nextSlide}>
                        <IoChevronForwardCircleOutline size={50} className="text-gray-700 hover:text-gray-900" />
                    </div>
                </div>
                <style jsx>{`
                    .lineheight {
                        line-height: 40px;
                    }

                    @media (min-width: 768px) {
                        .lineheight {
                            line-height: 60px;
                        }
                    }
                `}</style>
            </section>
            <YoutubeModal videoId={activeVideoId} onClose={() => setActiveVideoId(null)} />
        </>
    );
};

export const CasestudyCard: React.FC<CasestudyCardProps> = ({ imageUrl, title, externalLink, sector }) => {
    return (
        <div className="flex flex-col justify-between h-full hover:shadow-xl  mx-3 case-study-wrapper cursor-pointer bg-white " onClick={() => windowOpenNewTab(externalLink)}>
            <Image src={imageUrl} width={397} height={332} alt={sector} className="rounded-lg" />

            <div className="flex flex-col flex-grow p-6 gap-3">
                <p className="text-gray-600">{sector.toUpperCase()}</p>
                <p className="text-xl text-gray-900 font-medium mb-4 hover-text-color">{title}</p>
            </div>

            <div className="mt-auto p-6 w-full flex">
                <MdArrowOutward size={20} className="case-study-icon ml-auto" color="black" />
            </div>
            <style>{`
                .case-study-wrapper {
                    border-bottom: 3px solid #CBD5E0;
                    transition: border-bottom 0.3s ease;
                }
                .case-study-wrapper:hover {
                    border-bottom: 3px solid #3364FA;
                }
                .case-study-icon {
                    transition: transform 0.3s ease, color 0.3s ease;
                }
                .case-study-wrapper:hover .case-study-icon {
                    transform: rotate(49deg);
                    color: red;
                }
                .hover-text-color {
                    transition: color 0.3s ease;
                }
                .case-study-wrapper:hover .hover-text-color {
                    color: #3364FA;
                }
            `}</style>
        </div>
    );
};
